import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
const isDev = window.location.hostname.includes('dev.');
if (!isLocalhost && !isDev) {
    window.__originalConsoleLog = console.log;
    console.log = () => {};
}

// Global error handling to prevent white screens
window.addEventListener('error', (event) => {
  console.error('Global error caught:', event.error);
  
  // Don't interfere with React's own error handling
  if (event.error && event.error.message && 
      (event.error.message.includes('React') || 
       event.error.message.includes('Minified React error'))) {
    return;
  }
  
  // Store error info for debugging
  try {
    localStorage.setItem('root_error', JSON.stringify({
      timestamp: Date.now(),
      message: event.error?.message || event.message || 'Unknown error',
      stack: event.error?.stack || 'No stack trace'
    }));
    
    // Set recovery data to help app restore state
    localStorage.setItem('crash_recovery', 'true');
    
    // Create a brief message to the user
    const errorDiv = document.createElement('div');
    errorDiv.style.position = 'fixed';
    errorDiv.style.top = '50%';
    errorDiv.style.left = '50%';
    errorDiv.style.transform = 'translate(-50%, -50%)';
    errorDiv.style.backgroundColor = 'rgba(30, 17, 78, 0.95)';
    errorDiv.style.color = 'white';
    errorDiv.style.padding = '20px';
    errorDiv.style.borderRadius = '8px';
    errorDiv.style.zIndex = '9999';
    errorDiv.style.maxWidth = '80%';
    errorDiv.style.textAlign = 'center';
    errorDiv.innerHTML = `
      <h3 style="margin-top: 0; color: #FF5555;">Error Detected</h3>
      <p>The application encountered an error.</p>
      <button style="background: #6B46C1; border: none; color: white; padding: 8px 16px; border-radius: 4px; cursor: pointer; margin-top: 10px;" 
              onclick="window.location.reload()">
        Reload Application
      </button>
    `;
    
    // Only append if not already there
    if (!document.getElementById('global-error-message')) {
      errorDiv.id = 'global-error-message';
      document.body.appendChild(errorDiv);
    }
  } catch (e) {
    console.error('Error in error handler:', e);
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

// Start measuring performance
reportWebVitals();

// Service Worker Registration
// if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
//   window.addEventListener('load', () => {
//     const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;
    
//     navigator.serviceWorker
//       .register(swUrl)
//       .then(registration => {
//         console.log('ServiceWorker registration successful:', registration);
        
//         // Check for updates when the app gains focus
//         document.addEventListener('visibilitychange', () => {
//           if (!document.hidden) {
//             registration.update();
//           }
//         });
        
//         // Listen for update found
//         registration.addEventListener('updatefound', () => {
//           const installingWorker = registration.installing;
          
//           if (installingWorker) {
//             installingWorker.addEventListener('statechange', () => {
//               if (installingWorker.state === 'installed') {
//                 if (navigator.serviceWorker.controller) {
//                   // New update available
//                   console.log('New content is available; please refresh.');
                  
//                   // Show update notification to user
//                   const shouldUpdate = window.confirm(
//                     'A new version of the application is available. ' +
//                     'Would you like to update now?'
//                   );
                  
//                   if (shouldUpdate) {
//                     // Tell the service worker to skip waiting
//                     installingWorker.postMessage({ type: 'SKIP_WAITING' });
//                     window.location.reload(true);
//                   }
//                 } else {
//                   // Content is cached for offline use
//                   console.log('Content is cached for offline use.');
//                 }
//               }
//             });
//           }
//         });
        
//         // Handle controller change (when service worker updates)
//         let refreshing = false;
//         navigator.serviceWorker.addEventListener('controllerchange', () => {
//           if (!refreshing) {
//             refreshing = true;
//             window.location.reload(true);
//           }
//         });
//       })
//       .catch(error => {
//         console.error('ServiceWorker registration failed:', error);
//       });
//   });
  
//   // Listen for messages from service worker
//   navigator.serviceWorker.addEventListener('message', event => {
//     if (event.data && event.data.type === 'SW_UPDATED') {
//       console.log('Service worker updated to version:', event.data.version);
//     }
//   });
// }
